









import { Component, Vue } from 'vue-property-decorator';
import { ICacheService } from '@/services/iCacheService';
import { ObjectFactory } from '@/config/objectFactory';
import { MedTransGoConstants } from './util/constants';
import { DateUtils } from './util/dateUtils';
import Loader from './components/Loader.vue';
import SessionTimeout from './components/SessionTimeout.vue';
import RedirectMobileApp from './components/RedirectMobileApp.vue';
import { CommonUtils } from './util/commonUtils';
@Component({
    components: {
        Loader,
        SessionTimeout,
        RedirectMobileApp,
    },
})
export default class App extends Vue {
    private show: any = false;
    private IDLE_TIMEOUT = 10;
    private idleMinutesCounter = 0;
    private showTimeoutPop = false;
    private showRedirectMobileApp = false;
    // Lifecycle hook. Check if user is logged in
    // If not then redirect to login page
    public async mounted() {
        const os = CommonUtils.getMobileOperatingSystem();
        if ((os === 'Android' || os === 'iOS') && this.$route.path !== MedTransGoConstants.URL_TERMSANDCONDITIONS) {
            if (this.$route.path.startsWith('/requests') &&  this.$route.params.id) {
                const serviceType = 'service';
                location.href = `medtransgo://${serviceType}/${this.$route.params.id}`;
            } else {
                this.showRedirectMobileApp = true;
            }
        } else {
            if (!this.isPublicRoute()) {
                const iCacheService: ICacheService = ObjectFactory.getCacheService();
                let idToken = '';
                let state = '';
                if (this.$route.query.id_token) {
                    idToken = this.$route.query.id_token.toString();
                    iCacheService.saveValue(MedTransGoConstants.FIELD_NAME_TOKEN, idToken);
                    state = iCacheService.getSessionValue(MedTransGoConstants.FIELD_STATE);
                } else {
                    idToken = iCacheService.getValue(MedTransGoConstants.FIELD_NAME_TOKEN);
                }

                // Redirect to login page if token is expired
                if (idToken) {
                    const jsonPayload = iCacheService.getSessionInfo();
                    const currentTimeInMillis = DateUtils.getCurrentTimeInMillis();
                    const tokenExpireTime = jsonPayload.exp * 1000; // exp is time in seconds
                    // Token is expired
                    this.setRefreshTokenTask();
                    this.startIdleTimeCheck();
                    await this.getPartnerDetails();
                    if (tokenExpireTime < currentTimeInMillis) {
                        this.redirectToLogin();
                    } else if (jsonPayload.status === MedTransGoConstants.STATUS_SETUP_PENDING) {
                        this.show = true;
                        if (!this.$route.fullPath.startsWith(MedTransGoConstants.URL_ACCOUNT_SETUP)) {
                            const redirectTo = `${MedTransGoConstants.URL_ACCOUNT_SETUP}/${MedTransGoConstants.URL_PERSONAL_INFO}`;
                            this.$router.push(redirectTo);
                        } else if (this.$route.fullPath.startsWith(MedTransGoConstants.URL_ACCOUNT_SETUP)) {
                            this.show = true;
                        }
                    } else {
                        this.show = true;
                        if (state) {
                            this.$router.push(state);
                            iCacheService.removeSessionValue(MedTransGoConstants.FIELD_STATE);
                        }
                    }
                } else {
                    this.redirectToLogin();
                }
            } else {
                this.show = true;
            }
        }
    }

    private redirectToLogin() {
        ObjectFactory.getCacheService().saveSessionValue(MedTransGoConstants.FIELD_STATE, location.pathname);
        const redirectUrl = `${this.$store.state.serverUrl}${MedTransGoConstants.HTTP_URL_LOGIN}?clientId=${this.$store.state.clientId}`;
        location.href = redirectUrl;
    }

    private isPublicRoute(): boolean {
        return this.$store.state.publicUrl.indexOf(this.$route.path) >= 0;
    }

    private async setRefreshTokenTask() {
        const jsonPayload = ObjectFactory.getCacheService().getSessionInfo();
        const currentTimeInMillis = DateUtils.getCurrentTimeInMillis();
        const tokenExpireTime = jsonPayload.exp * 1000; // exp is time in seconds
        let refreshTokenTimeout = tokenExpireTime - currentTimeInMillis;
        const timeoutOffset = DateUtils.convertMinutesToMillis(2);
        refreshTokenTimeout = refreshTokenTimeout - (timeoutOffset <= refreshTokenTimeout ? timeoutOffset : 0);
        if (refreshTokenTimeout <= 0) {
            this.redirectToLogin();
        } else {
            setTimeout(() => {
                this.refreshToken();
            }, refreshTokenTimeout);
        }
    }

    private async refreshToken() {
        const response = await ObjectFactory.getRequestService()
            .refreshToken(this.$store.state.clientId, this.$store.state.serverUrl);
        if (response.success) {
            ObjectFactory.getCacheService().saveValue(MedTransGoConstants.FIELD_NAME_TOKEN, response.data);
            this.setRefreshTokenTask();
        } else {
            this.redirectToLogin();
        }
    }

    private startIdleTimeCheck() {
        document.onclick = () => {
            this.idleMinutesCounter = 0;
        };
        document.onmousemove = () => {
            this.idleMinutesCounter = 0;
        };
        document.onkeypress = () => {
            this.idleMinutesCounter = 0;
        };
        window.setInterval(this.checkIdleTime, 1000 * 60);
    }

    private checkIdleTime() {
        this.idleMinutesCounter++;
        if (this.IDLE_TIMEOUT <= this.idleMinutesCounter) {
            this.showTimeoutPop = true;
        }
    }

    private async getPartnerDetails() {
        const sessionInfo = ObjectFactory.getCacheService().getSessionInfo();
        if (sessionInfo.scopes.includes('interpreter')) {
            const partnerService = ObjectFactory.getPartnerService();
            const response = await partnerService.getPartnerProfile(this.$store.state.serverUrl);
            if (response.success && response.data && response.data.interpreterProfile) {
                if (response.data.interpreterProfile.parentInterpreterId) {
                    this.$store.commit('setChildInterpreter', true);
                }
            }
        }
    }

}
